// Markets where online booking is blocked (backend disableOnlineBooking) keep the full NPV block.
// A market status that failed to load is treated as closed so in-clinic slots never leak.
export const shouldHideInClinicNpvSlots = ({
  patientFacing,
  marketStatusFailed = false,
  onlineBookingUnavailable,
  newPatientVisit
}: {
  patientFacing?: boolean;
  marketStatusFailed?: boolean;
  onlineBookingUnavailable: boolean;
  newPatientVisit: boolean;
}) =>
  newPatientVisit && !onlineBookingUnavailable && (patientFacing === false || marketStatusFailed);
